import { Col, Row, Typography } from "antd";
import FormInput from "components/FormInput";
import Card from "features/Cart/components/Card";
import { t } from "i18next";
import ProductPromoCommonInfoFields from "./ProductPromoCommonInfoFields";
import useCampaignInfo from "./useCampaignInfo";

import "./index.scss";

const CampaignInfo = ({ form, isApplyWithPromotion, handleCheckIsApplyWithPromo, isUpdate }) => {
  const { commonInfoFields } = useCampaignInfo({
    form,
    isUpdate,
  });
  return (
    <div className="custom-form-campaign">
      <Card
        style={{ height: "100%" }}
        title={<Typography.Title level={5}>{t("campaign.form.commonInfo")}</Typography.Title>}
      >
        <Row gutter={[0, 20]}>
          {commonInfoFields.map((field, index) => (
            <Col span={24} key={index}>
              <FormInput {...field} />
            </Col>
          ))}
          <Col span={24}>
            <ProductPromoCommonInfoFields form={form} />
          </Col>
        </Row>
      </Card>
    </div>
  );
};

export default CampaignInfo;
